import React from 'react'
import Image from 'components/Common/Image/Image'
import styled from 'styled-components'
import { rem } from 'polished'

const ImageContainer = styled.div`
  position: relative;
  min-height: ${rem(125)};
  min-width: ${rem(330)};
  width: 100%;
  aspect-ratio: 672 / 250;
  overflow: hidden;
`

const LogoOverlay = styled.div`
  position: absolute;
  top: ${rem(12)};
  right: ${rem(12)};
  width: 30%;
  height: 20%;
`

function WineSelectorsBackground() {
  return (
    <ImageContainer>
      <Image
        image={{ id: 'wine-selectors-background' }}
        fit="center"
        objectFit="cover"
        alt="Wine Selectors Background"
      />
      <LogoOverlay>
        <Image
          image={{ id: 'wine-selectors-logo-inverse' }}
          fit="center"
          objectFit="contain"
          alt="Wine Selectors"
        />
      </LogoOverlay>
    </ImageContainer>
  )
}

export default WineSelectorsBackground
